export default __webpack_public_path__ + "images/58d5bdee93afe460523034c2ecfe57fe-celebration.svg";